import Vue from "vue";
import ngVueComponentsModule from "./ngVueComponentsModule";
import InterventionModal from "./intervention/InterventionModal.vue";
import RecurrenceInterventionModal from "./recurrence_intervention/RecurrenceInterventionModal.vue";
import UserRolesDisplay from "./user/UserRolesDisplay.vue";
import UserRolesEdit from "./user/UserRolesEdit.vue";
import InterventionDashboard from "./intervention/dashboard/InterventionDashboard.vue";
import FacturationDashboard from "./facturation/dashboard/FacturationDashboard.vue";
import AlertCount from "./intervention/dashboard/AlertCount.vue";
import ContactTagEdit from "./contact/ContactTagEdit.vue";
import PrintPlanning from "./intervention/PrintPlanning.vue";
import PlanificationInterventions from "./intervention/PlanificationInterventions.vue";
import MailEditor from "./core/Forms/MailEditor.vue";
import SendNotificationModal from "./journal/SendNotificationModal.vue";
import SendEmailModal from "./journal/SendEmailModal.vue";
import Journal from "./journal/Journal.vue";
import JournalEntryCommunicationTypeIcon from "./journal/JournalEntryCommunicationTypeIcon.vue";
import AbsenceModal from "./employe/AbsenceModal.vue";
import AbsenceList from "./employe/AbsenceList.vue";
import PrintRecapitulatifHeures from "./intervention/PrintRecapitulatifHeures.vue";
import EmployeContratList from "./employe/EmployeContratList.vue";
import RemplacementModal from "./recurrence_intervention/RemplacementModal.vue";
import RemplacementAlerts from "./recurrence_intervention/RemplacementAlerts.vue";
import FacturationModal from "./intervention/FacturationModal.vue";
import AppSettings from "./app/AppSettings.vue";
import InterventionsList from "./intervention/InterventionsList.vue";
import RecurringInterventionsList from "./recurrence_intervention/RecurringInterventionsList.vue";
import InterventionPhotos from "./intervention/InterventionPhotos.vue";
import EvenementPhotos from "./audit/EvenementPhotos.vue";
import DistancesList from "./trajet/DistancesList.vue";
import NoteButton from "./note/NoteButton.vue";
import EmployeEdit from "./employe/EmployeEdit.vue";
import MonthSelector from "./core/Forms/MonthSelector.vue";
import FraisDetailModal from "./trajet/FraisDetailModal.vue";
import TotalFrais from "./trajet/TotalFrais.vue";
import TotalFraisAll from "./trajet/TotalFraisAll.vue";
import FraisAttachments from "./trajet/FraisAttachments.vue";
import FraisPdf from "./trajet/FraisPdf.vue";
import ContactCoordsEdit from "./contact/ContactCoordsEdit.vue";
import CongesEmployesList from "./employe/CongesEmployesList.vue";
import FlotteList from "./controle_vehicule/FlotteList.vue";
import ControlesList from "./controle_vehicule/ControlesList.vue";
import ContactEdit from "./contact/ContactEdit.vue";
import AbsenceNotificationsList from "./notifications/AbsenceNotificationsList.vue";
import InterventionStatusNotificationsList from "./notifications/InterventionStatusNotificationsList.vue";
import Disponibilites from "./intervention/Disponibilites.vue";
import FactureFournisseurList from "./document/FactureFournisseurList.vue";
import AvisDeVirementList from "./document/AvisDeVirementList.vue";
import AvisDePrelevementList from "./document/AvisDePrelevementList.vue";
import BulletinDeSalaireList from "./document/BulletinDeSalaireList.vue";
import DocumentNonReconnuList from "./document/DocumentNonReconnuList.vue";
import ContactList from "./contact/ContactList.vue";
import DocumentProcessingCount from "./document/DocumentProcessingCount.vue";
import ProcessedDocumentsList from "./document/ProcessedDocumentsList.vue";
import ChangePasswordModal from "./app/ChangePasswordModal.vue";
import BodyPortalTarget from "./core/UI/BodyPortalTarget.vue";
import RelanceList from "./facture/RelanceList.vue";
import MobileAppReleasesList from "./mobile_app/MobileAppReleasesList.vue";
import CorbeilleList from "./corbeille/CorbeilleList.vue";
import ExportButton from "./core/UI/ExportButton.vue";
import SuiviMateriel from "./materiel/SuiviMateriel.vue";

/**
 * Directive Angular exposant un composant Vue, avec injection annotée
 * explicitement : les noms de paramètres sont renommés par la minification,
 * et le bundle .min.js échouait avec « Unknown provider: eProvider ».
 */
function vueDirective(name: string, component: any) {
    ngVueComponentsModule.directive(name, [
        "createVueComponent",
        (createVueComponent: any) =>
            createVueComponent(Vue.component(name, component)),
    ]);
}

vueDirective("interventionModal", InterventionModal);
vueDirective("recurrenceInterventionModal", RecurrenceInterventionModal);
vueDirective("sendNotificationModal", SendNotificationModal);
vueDirective("sendEmailModal", SendEmailModal);

vueDirective("userRolesDisplay", UserRolesDisplay);
vueDirective("userRolesEdit", UserRolesEdit);
vueDirective("interventionDashboard", InterventionDashboard);
vueDirective("facturationDashboard", FacturationDashboard);
vueDirective("alertCount", AlertCount);
vueDirective("contactTagEdit", ContactTagEdit);
vueDirective("printPlanning", PrintPlanning);
vueDirective("planificationInterventions", PlanificationInterventions);
vueDirective("mailEditor", MailEditor);
vueDirective("journal", Journal);
vueDirective("journalEntryCommunicationTypeIcon", JournalEntryCommunicationTypeIcon);
vueDirective("absenceModal", AbsenceModal);
vueDirective("absenceList", AbsenceList);
vueDirective("printRecapitulatifHeures", PrintRecapitulatifHeures);
vueDirective("employeContratList", EmployeContratList);
vueDirective("remplacementModal", RemplacementModal);
vueDirective("remplacementAlerts", RemplacementAlerts);
vueDirective("facturationModal", FacturationModal);
vueDirective("appSettings", AppSettings);
vueDirective("interventionsList", InterventionsList);
vueDirective("recurringInterventionsList", RecurringInterventionsList);
vueDirective("interventionPhotos", InterventionPhotos);
vueDirective("evenementPhotos", EvenementPhotos);
vueDirective("distancesList", DistancesList);
vueDirective("noteButton", NoteButton);
vueDirective("employeEdit", EmployeEdit);
vueDirective("monthSelector", MonthSelector);
vueDirective("fraisDetailModal", FraisDetailModal);
vueDirective("totalFrais", TotalFrais);
vueDirective("totalFraisAll", TotalFraisAll);
vueDirective("fraisAttachments", FraisAttachments);
vueDirective("fraisPdf", FraisPdf);
vueDirective("contactCoordsEdit", ContactCoordsEdit);
vueDirective("congesEmployesList", CongesEmployesList);
vueDirective("contactEdit", ContactEdit);
vueDirective("flotteList", FlotteList);
vueDirective("controlesVehiculeList", ControlesList);
vueDirective("absenceNotificationsList", AbsenceNotificationsList);
vueDirective("interventionStatusNotificationsList", InterventionStatusNotificationsList);
vueDirective("disponibilites", Disponibilites);
vueDirective("factureFournisseurList", FactureFournisseurList);
vueDirective("avisDeVirementList", AvisDeVirementList);
vueDirective("avisDePrelevementList", AvisDePrelevementList);
vueDirective("bulletinDeSalaireList", BulletinDeSalaireList);
vueDirective("documentNonReconnuList", DocumentNonReconnuList);
vueDirective("clientList", ContactList);
vueDirective("documentProcessingCount", DocumentProcessingCount);
vueDirective("processedDocumentsList", ProcessedDocumentsList);
vueDirective("changePasswordModal", ChangePasswordModal);
vueDirective("bodyPortalTarget", BodyPortalTarget);
vueDirective("relanceList", RelanceList);

vueDirective("mobileAppReleasesList", MobileAppReleasesList);
vueDirective("corbeilleList", CorbeilleList);

vueDirective("exportButton", ExportButton);

vueDirective("suiviMateriel", SuiviMateriel);
